// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectCrossRateMessage extends DirectMessageBaseClass {
    constructor(crossRateDataArray) {
        super(Message.CODE_CROSSRATE_MESSAGE);
        this.CrossRateData = crossRateDataArray;
    }
}
